import moment from 'moment';

import { allModelsSelector } from 'common-src/utils/selectorUtils';

import { activeStatusesIds } from './constants';

export const getPatientMedications = (state, patientId) =>
  allModelsSelector(state, 'PatientMedication', (pm) => pm.patientId === patientId);

export const getActivePatientMedications = (state, patientId) =>
  getPatientMedications(state, patientId)
    .filter(
      (pm) =>
        (!pm.activeTill || moment(pm.activeTill).isAfter(moment.now())) &&
        activeStatusesIds.includes(pm?.status),
    )
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
